import { useContext } from 'react';
import { Module } from '../../../../../api/module';
import { MiniDialogMedialink } from '../../../../../api/medialink';
import ModalContext from '../../../../../contexts/ModalContext';
import MiniDialog from '../../../../../shared-components/elementis/components/mini-dialog-modal';

import '../../../../../scss/ianua/components/mini-dialog.scss';
import { useTranslation } from 'react-i18next';
import { useRoutes } from '../../../../../hooks/useRoutes';

const getTranslations = ({
  t,
  getRoute,
}: Pick<ReturnType<typeof useTranslation>, 't'> & Pick<ReturnType<typeof useRoutes>, 'getRoute'>) => ({
  closeDialog: t('ACTIONS.CLOSE'),
  generalNode: t('TOC.GENERAL'),
  playDialog: t('SHARED_COMPONENTS.MINI_DIALOGS.PLAY_ENTIRE_DIALOG'),
  stopDialog: t('SHARED_COMPONENTS.MINI_DIALOGS.STOP_DIALOG'),
  example: t('SHARED_COMPONENTS.MINI_DIALOGS.EXAMPLE'),
  ownVoice: t('SHARED_COMPONENTS.MINI_DIALOGS.OWN_VOICE'),
  optionsTextAndSound: t('SHARED_COMPONENTS.MINI_DIALOGS.OPTIONS_TEXT_AND_SOUND'),
  optionsKeyWords: t('SHARED_COMPONENTS.MINI_DIALOGS.OPTIONS_CORE_WORDS'),
  playTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.PLAY_TITLE'),
  pauseTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.PAUSE_TITLE'),
  recordTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.RECORD_TITLE'),
  stopRecordTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.STOP_RECORD_TITLE'),
  playRecordingTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.PLAY_RECORDING_TITLE'),
  pauseRecordingTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.PAUSE_RECORDING_TITLE'),
  hideTextTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.HIDE_TEXT_TITLE'),
  showTextTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.SHOW_TEXT_TITLE'),
  hideKeywordsTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.HIDE_KEYWORDS_TITLE'),
  showKeywordsTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.SHOW_KEYWORDS_TITLE'),
  muteTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.MUTE_TITLE'),
  unmuteTitle: t('SHARED_COMPONENTS.MINI_DIALOGS.UNMUTE_TITLE'),
  errors: {
    browserSupport: t('SHARED_COMPONENTS.MINI_DIALOGS.ERRORS.NO_RECORD_RTC_SUPPORTED', {
      faqURL: getRoute('HELP'),
    }),
    accessDenied: t('SHARED_COMPONENTS.MINI_DIALOGS.ERRORS.NO_PERMISSION_GIVEN', { faqURL: getRoute('HELP') }),
    noMicrophone: t('SHARED_COMPONENTS.MINI_DIALOGS.ERRORS.NO_MIC_FOUND'),
  },
  a11y: {
    label: t('SHARED_COMPONENTS.MINI_DIALOGS.A11Y_LABEL'),
  },
});

type Props = {
  id: string;
  medialink: MiniDialogMedialink;
  module: Module;
};

export default function MiniDialogModal({ id, medialink, module }: Props) {
  const { closeModal } = useContext(ModalContext);
  const { getRoute } = useRoutes();
  const { t } = useTranslation();

  return (
    <MiniDialog
      mediaLink={medialink}
      onClose={() => closeModal(id)}
      superModuleHasExerciseEntrance={module.hasExerciseEntrance}
      urlPrefix={process.env.REACT_APP_P_API_URL}
      studioGroup={process.env.REACT_APP_P_STUDIO_GROUP}
      translations={getTranslations({ t, getRoute })}
    />
  );
}
